import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

type AppleLogoProps = {
  size?: number;
  color?: string;
};

const APPLE_MARK_PATH =
  'M16.365 1.43c0 1.14-.415 2.206-1.149 3.026-.79.88-2.09 1.556-3.27 1.463-.13-1.098.48-2.242 1.21-3.02C13.96 2.09 15.27 1.46 16.365 1.43zM20.76 17.39c-.63 1.46-.93 2.11-1.74 3.4-1.13 1.78-2.73 4-4.71 4.01-1.76.02-2.21-1.15-4.6-1.14-2.39.01-2.88 1.16-4.64 1.14-1.98-.02-3.5-2.02-4.63-3.8-3.16-4.96-3.49-10.78-1.54-13.87C1.3 5.01 3.05 3.8 4.9 3.78c1.86-.03 3.05 1.25 4.6 1.25 1.54 0 2.48-1.25 4.69-1.21 1.78.03 3.4.97 4.36 2.47-3.83 2.1-3.21 7.57.21 9.1z';

function appleMarkDataUri(color: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${color}"><path d="${APPLE_MARK_PATH}"/></svg>`;
  return `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}")`;
}

/** Square CSS background — no img/svg child for RN-web flex to stretch. */
export function AppleLogo({ size = 18, color = '#FFFFFF' }: AppleLogoProps) {
  return (
    <View
      pointerEvents="none"
      style={[
        styles.box,
        {
          width: size,
          height: size,
          backgroundImage: appleMarkDataUri(color),
        } as ViewStyle,
      ]}
    />
  );
}

const styles = StyleSheet.create({
  box: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 18,
    alignSelf: 'center',
    overflow: 'hidden',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
  } as ViewStyle,
});
